import { FormattedMessage, useIntl } from 'react-intl'

import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { SecondaryInfo } from 'features/App/components/SecondaryInfo'
import { WasteItems } from 'features/Inventories/components/WasteItems'
import { WasteStatus } from 'features/Inventories/components/WasteStatus'
import { lostTypeMessages } from 'features/Snacks/components/LostType/messages'
import { safeFormatMessage } from 'utils/intl'

export const WastesList = ({ wastes = [] }): TSFixMe => {
  const intl = useIntl()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="spanish.dictionary.id" defaultMessage="Id" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.createdAt" defaultMessage="Fecha de creación" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.status" defaultMessage="Estado" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.wastes.list.inventory" defaultMessage="Inventario" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.wastes.list.user" defaultMessage="Registrado por" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.wastes.list.reason" defaultMessage="Razón" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.wastes.list.items" defaultMessage="Productos" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.wastes.list.total" defaultMessage="Total" />
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {wastes.map((waste: TSFixMe): TSFixMe => {
            return (
              <Tr key={waste.id}>
                <Td>
                  <CopyToClipboardWrapper>
                    <div>{waste.id.substring(0, 8)}</div>

                    <CopyToClipboard str={waste.id} />
                  </CopyToClipboardWrapper>
                </Td>

                <Td>
                  <FormattedDate intl={intl} value={waste.createdAt} month="2-digit" day="2-digit" year="numeric" />

                  <SecondaryInfo>
                    <FormattedTimeByDate intl={intl} date={waste.createdAt} />
                  </SecondaryInfo>
                </Td>

                <Td>
                  <WasteStatus status={waste.status} />
                </Td>

                <Td>{waste.inventory && waste.inventory.name}</Td>

                <Td>
                  {waste.user.firstName} {waste.user.lastName}
                </Td>

                <Td>{safeFormatMessage({ intl, messages: lostTypeMessages, key: waste.reason })}</Td>

                <Td>
                  <WasteItems items={waste.items} />
                </Td>

                <Td>
                  <FormattedPrice value={waste.amount} />
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
